import { render, staticRenderFns } from "./CompDetailOrder.vue?vue&type=template&id=4ee9f5db"
import script from "./CompDetailOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./CompDetailOrder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports